import { useCallback } from 'react'
import { baseUrl } from '@fs/zion-config'
import { useLazyQuery, useMutation } from '@apollo/client/react'
import { useQueryParams } from '@fs/zion-router'
import queries from '../views/metadataAudit/queries'
import { getCurrentWorkflowActions, workflowStatuses } from '../views/imageBrowse/helpers'
import { useImageAuditContext } from './useImageAuditContext'
import mutations from '../views/imageBrowse/mutations'
import fsOperationsCallHeader from '../utils/fsOperationsCallHeader'

export default function useReturnToAudit() {
  const { query } = useQueryParams()
  const mode = query?.mode
  const { group } = useImageAuditContext()
  const [doUpdateWorkflowActionStatus] = useMutation(mutations.updateWorkflowActionStatus())

  const [fetchWorkflowActions] = useLazyQuery(queries.workflowActions(), {
    fetchPolicy: 'no-cache',
  })

  const returnToAudit = useCallback(
    async (projectId) => {
      // find the current audit's workflow action
      const currentWorkflowActions = await getCurrentWorkflowActions(fetchWorkflowActions, group)
      const foundAuditWorkflowAction = currentWorkflowActions?.find((workflowAction) => {
        if (mode === 'imageQualityAudit') {
          return workflowAction?.name === workflowStatuses.IMAGE_QUALITY_AUDIT
        }
        return workflowAction?.name === workflowStatuses.IMAGE_METADATA_AUDIT
      })
      if (foundAuditWorkflowAction?.status === 'In Progress') {
        // reset audit to available
        const metisAuditResponse = await doUpdateWorkflowActionStatus({
          variables: {
            params: {
              action:
                mode === 'imageQualityAudit'
                  ? workflowStatuses.IMAGE_QUALITY_AUDIT
                  : workflowStatuses.IMAGE_METADATA_AUDIT,
              newStatus: 'Available',
              rmsId: group?.id,
              createNewWorkflowAction: false,
            },
          },
          context: { headers: { ...fsOperationsCallHeader } },
        })
        if (!metisAuditResponse?.data?.updateWorkflowActionStatus?.code === '204') {
          console.error(
            `metisAuditResponse returned code of ${metisAuditResponse?.data?.updateMetisProjectStatus?.code}`
          )
        }
      }

      backToAuditListOfParentProject(projectId, mode)
    },
    [doUpdateWorkflowActionStatus, fetchWorkflowActions, group, mode]
  )

  return { returnToAudit }
}

function backToAuditListOfParentProject(projectId, mode) {
  let auditProjectId
  if (!projectId || Array.isArray(projectId)) {
    const { projectId: projectIdFromStorage } = localStorage.getItem(
      mode === 'imageQualityAudit' ? 'react-audit-quality' : 'react-audit-data'
    )
      ? JSON.parse(localStorage.getItem(mode === 'imageQualityAudit' ? 'react-audit-quality' : 'react-audit-data'))
      : { projectId: null }
    auditProjectId = projectIdFromStorage
  } else {
    auditProjectId = projectId
  }
  window.location.assign(
    `${process.env.NODE_ENV === 'development' ? 'http://localhost:5001' : `${baseUrl}/records`}/audit${
      auditProjectId ? `/${auditProjectId}` : ''
    }`
  )
}
